import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';
import configuratorModule from './configurator/configuratorModule';
import modelSelectionModule from './configurator/modelSelectionModule';
import functionsModule from './configurator/functionsModule';
import frameModule from './configurator/frameModule';
import measureModule from './configurator/measureModule';
import doorLeafSurfaceModule from './configurator/doorLeafSurfaceModule';
import exteriorAccessoryModule from './configurator/exteriorAccessoryModule';
import mountingMaterialModule from './configurator/mountingMaterialModule';
import blindstockMultiplexModule from './configurator/blindstockMultiplexModule';
import furtherInformationModule from './configurator/furtherInformationModule';

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    isAuthenticated: localStorage.getItem('token') ? true : false,
    user: {},
    languages: [],
    currentProduct: {},
    myMessage: 'Hello Door Configurator!',
    configurationChanged: false,
    prevRoute: ''
  }
}

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

export default new Vuex.Store({
  plugins: [vuexLocalStorage.plugin],
  modules : {
    configuratorModule,
    modelSelectionModule,
    functionsModule,
    frameModule,
    measureModule,
    doorLeafSurfaceModule,
    exteriorAccessoryModule,
    mountingMaterialModule,
    blindstockMultiplexModule,
    furtherInformationModule
  },
  
  state: getDefaultState(),
  getters: {
    isAuthenticated: (state: any) => {
      return state.isAuthenticated;
    },
    getCurrentUser(state: any) {
      return state.user;
    },
    getUserType(state: any) {
      return state.user.userType;
    },
    getCurrentProduct(state: any){
      return state.currentProduct;
    },
    languages(state) {
      return state.languages
    },
    getPrevRoute(state) {
      return state.prevRoute;
    }
  },
  actions: {
    storeUser(context, payload) {
      context.commit('storeUser', payload);
    },
    storeRoute(context, payload) {
      context.commit('storeRoute', payload);
    },
    logout(context){
      localStorage.clear();
      context.commit('logout');
    },
    storeCurrentProduct(context, payload){
      context.commit('storeCurrentProduct', payload);
    },
    setCurrentProductChangedPrice(context,payload)
    {
      context.commit('setCurrentProductChangedPrice', payload);
    },
    setLanguages(context, payload) {
      context.commit('setLanguages', payload)
    },
    setPreferredLanguage(context, payload) {
      context.commit('setPreferredLanguage', payload)
    },
    setConfigurationStatus(context, payload){
      context.commit('setConfigurationStatus', payload)
    }
  },
  mutations: {
    setLanguages(state, payload) {
      state.languages = payload
    },
    storeUser(state, payload) {
      state.user = payload;
      state.isAuthenticated = true;
    },
    logout(state){
      state.isAuthenticated = false;
    },
    storeCurrentProduct(state,payload) {
      state.currentProduct = payload;
    },
    setCurrentProductChangedPrice(state,payload){
      state.currentProduct.changedPrice = payload;
    },
    setPreferredLanguage(state, payload) {
      state.user.preferedLanguage = payload
    },
    setConfigurationStatus(state, payload){
      state.configurationChanged = payload
    },
    storeRoute(state, payload){
      state.prevRoute = payload
    }
  },
})
